import { useState } from 'react';

const faqs = [
  {
    question: 'Tianyi 文件系统支持哪些文件格式？',
    answer:
      'Tianyi 支持超过 100 种常见文件格式的在线预览，包括 Word、Excel、PPT、PDF、图片、视频、CAD 图纸、PSD 设计稿等。对于不支持在线预览的格式，您可以直接下载到本地查看。',
  },
  {
    question: '数据安全性如何保障？',
    answer:
      '我们采用 AES-256 端到端加密技术，所有文件在传输和存储过程中均处于加密状态。同时支持多层权限控制、操作审计日志、水印保护等功能，全面满足企业级安全合规要求。',
  },
  {
    question: '是否支持私有化部署？',
    answer:
      '企业版用户可以选择私有化部署方案，将 Tianyi 文件系统部署在您自己的服务器上，所有数据完全由您掌控。我们提供专业的技术团队协助完成部署与运维。',
  },
  {
    question: '如何与现有系统集成？',
    answer:
      'Tianyi 提供完善的 RESTful API 和 SDK，支持与企业微信、钉钉、飞书等主流办公平台无缝集成，也可以对接您现有的 OA、ERP 等业务系统。',
  },
  {
    question: '免费版有哪些限制？',
    answer:
      '免费版提供 5GB 存储空间，支持 3 个协作者，以及基础的文件上传、分享和 7 天版本历史功能。对于个人用户和小团队来说，完全足够日常使用。',
  },
  {
    question: '是否支持文件外部分享？',
    answer:
      '当然支持！您可以生成带密码保护和有效期限制的分享链接，将文件安全地分享给外部合作伙伴。接收方无需注册账号即可查看和下载文件。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="font-label text-xs md:text-sm font-medium tracking-widest text-foreground-500 uppercase mb-3">
            常见问题
          </p>
          <h3 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
            您可能想<span className="italic">了解</span>的
          </h3>
        </div>

        <div className="rounded-2xl overflow-hidden">
          <div className="aspect-[16/7] rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20with%20soft%20warm%20beige%20and%20cream%20tones%2C%20artistic%20film%20grain%20texture%2C%20subtle%20layered%20shapes%2C%20modern%20elegant%20atmosphere%2C%20corporate%20art%20style&width=1200&height=525&seq=faq-art-fs&orientation=landscape"
              alt="常见问题"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-all duration-200"
              >
                <button
                  className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-${
                      openIndex === index ? 'subtract' : 'add'
                    }-line text-foreground-500 text-lg flex-shrink-0 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-5 md:px-6 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed border-t border-background-200/70 pt-4">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}